import React, { PureComponent } from "react";
import cx from "classnames";
import { Link, navigate } from "gatsby";
import smoothscroll from "smoothscroll-polyfill";

import Navbar from "../../Navbar";
import Footer from "../../Footer";

import styles from "./ClientBase.module.scss";
import { FaPlayCircle } from "react-icons/fa";

export default class ClientBase extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      showLearnMore: false,
      playVideo: false,
      showTheBrand: false,
      showBrandDesign: false,
      showWebDesign: false,
      showSocialDesign: false
    };

    this.scrollCont = null;

    this.viewHeight = 0;
    this.viewWidth = 0;
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        loaded: true
      });
      const loaderElem = document.getElementById("loader");
      if (loaderElem) {
        loaderElem.parentNode.removeChild(loaderElem);
      }
    }, 0);

    setTimeout(() => {
      this.setState({
        showLearnMore: true
      });
    }, 500);

    this.viewWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    this.viewHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0
    );
    if (this.viewWidth < 800 || this.viewHeight < 450) {
      this.setState({
        isMobile: true
      });
    }

    this.scrollCont = document.getElementById("scroll-cont");

    smoothscroll.polyfill();
  }

  onScroll = e => {
    const scrollTop = e.target.scrollTop;
    const scrollLeft = e.target.scrollLeft;

    if (this.state.isMobile) {
      if (scrollTop > this.viewHeight && !this.state.transformNav) {
        this.setState({ transformNav: true });
      } else if (scrollTop < this.viewHeight && this.state.transformNav) {
        this.setState({ transformNav: false });
      }

      // the brand
      if (scrollTop > this.viewHeight / 2 && !this.state.showTheBrand) {
        this.setState({ showTheBrand: true });
      }
    } else {
      if (scrollLeft > this.viewWidth / 2 && !this.state.transformNav) {
        this.setState({ transformNav: true });
      } else if (scrollLeft < this.viewWidth / 2 && this.state.transformNav) {
        this.setState({ transformNav: false });
      }

      // the brand
      if (scrollLeft > this.viewWidth / 2.5 && !this.state.showTheBrand) {
        this.setState({ showTheBrand: true });
      }
      // the design
      if (scrollLeft > this.viewWidth * 1.25 && !this.state.showBrandDesign) {
        this.setState({ showBrandDesign: true });
      }
      // web design
      if (scrollLeft > this.viewWidth * 2.5 && !this.state.showWebDesign) {
        this.setState({ showWebDesign: true });
      }
      // social design
      if (scrollLeft > this.viewWidth * 3.5 && !this.state.showSocialDesign) {
        this.setState({ showSocialDesign: true });
      }
    }
  };

  onWheel = e => {
    this.scrollCont.scrollLeft += e.deltaY;
  };

  animateRight = () => {
    document
      .getElementById("page-two")
      .scrollIntoView({ block: "start", behavior: "smooth" });
  };

  render() {
    const {
      loaded,
      showLearnMore,
      playVideo,
      transformNav,
      isMobile,
      showTheBrand,
      showBrandDesign,
      showWebDesign,
      showSocialDesign
    } = this.state;
    const {
      mainImgStyle,
      title,
      video,
      theBrand,
      ourWork,
      brandDesign,
      featureImg,
      webDesignText,
      webDesignImg,
      socialDesignTitle,
      socialDesignText,
      socialDesignImg
    } = this.props;

    const videoElem = (
      <div className={styles.VideoWrapper}>
        <div style={!playVideo ? {} : { display: "none" }}>
          <div className={styles.VideoPlaceholder}>
            <FaPlayCircle
              onClick={() => {
                this.setState({ playVideo: true });
              }}
            />
          </div>
        </div>
        <div style={playVideo ? {} : { display: "none" }}>
          <video className={styles.Video} controls>
            <source src={video} type="video/mp4" />
          </video>
        </div>
      </div>
    );

    return (
      <div className={cx(styles.ClientBase, { [styles.Loaded]: loaded })}>
        <Navbar
          goTo={page => {
            navigate(`/#${page}`);
          }}
          pathname="clients"
          coverWhite={isMobile && transformNav}
          coverWhiteNah={
            (isMobile && !transformNav) || (!isMobile && !transformNav)
          }
        />
        <div className={cx(styles.Page, { [styles.Active]: loaded })}>
          <div className={styles.Large}>
            <div
              onScroll={this.onScroll}
              id="scroll-cont"
              onWheel={this.onWheel}
              className={styles.ScrollWrapper}
            >
              <div className={styles.ScrollInner}>
                <div className={cx(styles.Box, styles.One)}>
                  <div className={styles.Section}>
                    <div
                      className={cx(styles.MainImg, mainImgStyle, {
                        [styles.MainImgMobileLine]: showLearnMore
                      })}
                    />
                    <div className={styles.MainTitle}>{title}</div>
                    <a
                      className={cx(styles.LearnMore, {
                        [styles.LoadedLearnMore]: showLearnMore
                      })}
                      onClick={this.animateRight}
                    >
                      Learn More
                    </a>
                  </div>
                </div>
                <div className={cx(styles.Box, styles.Two)} id="page-two">
                  <div className={styles.Section}>
                    <div
                      className={cx(styles.TheBrand, {
                        [styles.ShowTheBrand]: showTheBrand
                      })}
                    >
                      <div>
                        <h3>The Brand</h3>
                        <p>{theBrand}</p>
                        <h3>Our Work</h3>
                        <ul>
                          {ourWork.map((work, i) => (
                            <li key={i}>{work}</li>
                          ))}
                        </ul>
                      </div>
                      {videoElem}
                    </div>
                  </div>
                </div>
                <div className={cx(styles.Box, styles.Three)}>
                  <div className={styles.Section}>
                    <div
                      style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center"
                      }}
                      className={styles.HideOnSmall}
                    >
                      <div
                        style={{
                          height: "50%",
                          flexBasis: "33%",
                          whiteSpace: "pre-wrap",
                          flexShrink: 0
                        }}
                        className={cx(styles.BrandDesignDiv, {
                          [styles.ShowBrandDesignDiv]: showBrandDesign
                        })}
                      >
                        <h3
                          style={{
                            marginTop: "20px"
                          }}
                        >
                          Brand Design
                        </h3>
                        <p>{brandDesign}</p>
                      </div>
                      <div className={styles.FeatureImg}>
                        <div
                          style={{ backgroundImage: `url(${featureImg})` }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={cx(styles.Box, styles.Four)}>
                  <div className={styles.Section}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                      className={styles.HideOnSmall}
                    >
                      <div
                        className={cx(styles.WebDesignText, {
                          [styles.ShowWebDesignText]: showWebDesign
                        })}
                      >
                        <h3>Web Design</h3>
                        <p style={{ whiteSpace: "pre-wrap" }}>
                          {webDesignText}
                        </p>
                      </div>
                      <div
                        className={cx(styles.ShowSmall, styles.WebDesignMobile)}
                      >
                        <h3>Web Design</h3>
                      </div>
                      <div className={styles.FeatureGif}>
                        <div>
                          <img src={webDesignImg} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={cx(styles.Box, styles.Five)}>
                  <div className={styles.Section}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}
                    >
                      <div
                        className={cx(styles.ShowSmall, styles.WebDesignMobile)}
                      >
                        <h3>
                          {socialDesignTitle
                            ? socialDesignTitle
                            : "Social Design"}
                        </h3>
                      </div>
                      <div className={styles.SocialDesignBlock}>
                        <div className={styles.IphoneImg}>
                          <div
                            style={{
                              backgroundImage: `url(${socialDesignImg})`
                            }}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginLeft: "30px",
                            marginTop: "14%"
                          }}
                          className={styles.HideEntireOnSmall}
                        >
                          <div
                            className={cx(styles.SocialDesignDiv, {
                              [styles.ShowSocialDesignDiv]: showSocialDesign
                            })}
                          >
                            <h3>
                              {socialDesignTitle
                                ? socialDesignTitle
                                : "Social Design"}
                            </h3>
                            <p style={{ whiteSpace: "pre-wrap" }}>
                              {socialDesignText}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className={styles.ReturnToProjects}>
                        <Link to="/#work">Return to Projects</Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.Small} onScroll={this.onScroll}>
            <div className={cx(styles.Box, styles.One)}>
              <div className={styles.Section}>
                <div
                  className={cx(styles.MainImg, mainImgStyle, {
                    [styles.MainImgMobileLine]: showLearnMore
                  })}
                />
                <div className={styles.MainTitle}>{title}</div>
                <a
                  className={cx(styles.LearnMore, {
                    [styles.LoadedLearnMore]: showLearnMore
                  })}
                  onClick={this.animateRight}
                >
                  Learn More
                </a>
              </div>
            </div>
            <div
              className={cx(styles.TheBrand, {
                [styles.ShowTheBrand]: showTheBrand
              })}
              style={{ height: "auto" }}
            >
              <div>
                <h3>The Brand</h3>
                <p>{theBrand}</p>
                <h3>Our Work</h3>
                <ul>
                  {ourWork.map((work, i) => (
                    <li key={i}>{work}</li>
                  ))}
                </ul>
              </div>
              {videoElem}
            </div>
            <div className={styles.FeatureImg}>
              <div style={{ backgroundImage: `url(${featureImg})` }} />
            </div>
            <div
              style={{
                width: "100%",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "50px"
              }}
            >
              <div className={cx(styles.ShowSmall, styles.WebDesignMobile)}>
                <h3>Web Design</h3>
              </div>
              <div className={styles.FeatureGif}>
                <div>
                  <img src={webDesignImg} />
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                height: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "75px"
              }}
            >
              <div className={cx(styles.ShowSmall, styles.WebDesignMobile)}>
                <h3>
                  {socialDesignTitle ? socialDesignTitle : "Social Design"}
                </h3>
              </div>
              <div
                className={styles.SocialDesignBlock}
                style={{ height: "50vh" }}
              >
                <div className={styles.IphoneImg}>
                  <div
                    style={{
                      backgroundImage: `url(${socialDesignImg})`
                    }}
                  />
                </div>
              </div>
              <div className={styles.ReturnToProjects}>
                <Link to="/#work">Return to Projects</Link>
              </div>
            </div>
            <div className={cx(styles.ShowSmall, styles.Return)}>
              <button
                onClick={() => {
                  navigate("/#work");
                }}
              >
                Back to Projects
              </button>
            </div>
          </div>
        </div>
        <Footer
          goTo={page => {
            navigate(`/#${page}`);
          }}
        />
      </div>
    );
  }
}
